import {Component, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../../../../shared/services/api.service';
import {EnrollService} from '../../../../shared/services/enroll.service';
import {FormService} from '@satoris/ngx-satoris';
import {format, addYears} from 'date-fns';

@Component({
  selector: 'app-activation-step-doc-exp-date',
  templateUrl: './activation-step-doc-exp-date.component.html',
  styleUrls: ['./activation-step-doc-exp-date.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivationStepDocExpDateComponent {
  minDate = format(new Date(), 'yyyy-MM-dd');
  maxDate = format(addYears(new Date(), 100), 'yyyy-MM-dd');

  constructor(public api: ApiService, 
    public enroll: EnrollService, 
    public forms: FormService) {
    if(this.api.userInfo.nationalNumber && this.api.userRole.isCustomer) {
      this.api.setPrincipalMode = true;
    }
  }

  ngOnDestroy() {
    this.api.setPrincipalMode = false;
  }
}
